import type { SVGProps } from 'react';
const DawnFlagAD = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-AD_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-AD_svg__a)">
      <path fill="#1537D1" d="M0 0h22v16H0z" />
      <path fill="#EA3058" d="M10.477 0h11.524v16H10.477z" />
      <path
        fill="#FFCF3C"
        fillRule="evenodd"
        d="M7.333 16h7.333V0H7.333z"
        clipRule="evenodd"
      />
      <path
        fill="#FFEDB1"
        fillRule="evenodd"
        d="M9.952 6.933H11v.534H9.952z"
        clipRule="evenodd"
      />
      <path
        stroke="#D32E28"
        strokeWidth={0.667}
        d="M10.152 6.733h1.696c.195 0 .348.167.332.36l-.103 1.255a1 1 0 0 1-.996.919h-.162a1 1 0 0 1-.997-.919L9.82 7.094a.333.333 0 0 1 .332-.36Z"
      />
      <path
        fill="#D32E28"
        fillRule="evenodd"
        d="M9.952 7.467h2.095V8H9.952z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagAD;
